// Library imports
import React from "react";

// User Component imports
import { TextInput } from "_core/components/common/UI";
import { DEMO_RELOAD_SEC_DEFAULT, DEMO_RELOAD_SEC_MIN, DEMO_RELOAD_SEC_MAX, reloadHint } from "../utils/demoPage";

/**
 * 自動リロードの ON/OFF と秒数（作成フォームと設定変更で共通）
 */
const DemoReloadField = ({ isAutoReload, reloadSec, disabled, onChangeAutoReload, onChangeReloadSec }) => (
    <div className="ops-demo-form is-reload">
        <label className={"ops-demo-switch " + (isAutoReload ? "on" : "off")}>
            <input type="checkbox" checked={isAutoReload} disabled={disabled}
                onChange={(e) => onChangeAutoReload(e.target.checked)} />
            <span className="switch-track"><span className="switch-thumb" /></span>
            <span className="switch-label">自動リロードする</span>
        </label>
        <div className="ops-demo-sec-row">
            <TextInput type="number" parentClassName="ops-demo-sec-input" default={reloadSec}
                onchange={(e) => onChangeReloadSec(e.target.value)} disabled={!isAutoReload || disabled}
                placeholder={String(DEMO_RELOAD_SEC_DEFAULT)} />
            <span className="ops-demo-sec-unit">秒</span>
            <span className="ops-demo-sec-hint">{reloadHint(isAutoReload, reloadSec)}</span>
        </div>
        <div className="ops-demo-form-hint">{DEMO_RELOAD_SEC_MIN}〜{DEMO_RELOAD_SEC_MAX} 秒。既定は {DEMO_RELOAD_SEC_DEFAULT} 秒（1時間）。</div>
    </div>
);

export default DemoReloadField;
